import React, { useState } from "react";
import ReelsManager from "../ReelsAndShorts/ReelsManager";
import SocialPostManager from "../SocialPostManager/SocialPostManager";
import SpotifyAudioManager from "../SpotifyAudioManager/SpotifyAudioManager";
import { Typography, Box } from "@mui/material";
import styles from "./SocialMediaManager.module.css";
import YoutubeVideoManager from "../YoutubeVideoManager/YoutubeVideoManager";

function SocialMediaManager() {
  const [activeSection, setActiveSection] = useState("reels");

  return (
    <div className={styles.container}>
      <h1 className={styles.mainTitle}>Manage Your Social Media</h1>
      <div className={styles.toggleButtons}>
        <button
          className={`${styles.toggleButton} ${
            activeSection === "reels" ? styles.active : ""
          }`}
          onClick={() => setActiveSection("reels")}
        >
          Instagram Reels
        </button>
        <button
          className={`${styles.toggleButton} ${
            activeSection === "youtube" ? styles.active : ""
          }`}
          onClick={() => setActiveSection("youtube")}
        >
          YouTube Video & Shorts
        </button>
        <button
          className={`${styles.toggleButton} ${
            activeSection === "social" ? styles.active : ""
          }`}
          onClick={() => setActiveSection("social")}
        >
          Social Posts
        </button>
        <button
          className={`${styles.toggleButton} ${
            activeSection === "podcasts" ? styles.active : ""
          }`}
          onClick={() => setActiveSection("podcasts")}
        >
          Podcasts
        </button>
      </div>

      <div className={styles.content}>
        {activeSection === "reels" && (
          <div className={`${styles.section} ${styles.fadeIn}`}>
            <ReelsManager />
          </div>
        )}
        {activeSection === "youtube" && (
          <div className={`${styles.section} ${styles.fadeIn}`}>
            <YoutubeVideoManager />
          </div>
        )}
        {activeSection === "social" && (
          <div className={`${styles.section} ${styles.fadeIn}`}>
            <SocialPostManager />
          </div>
        )}
        {activeSection === "podcasts" && (
          <div className={`${styles.section} ${styles.fadeIn}`}>
            <SpotifyAudioManager />
          </div>
        )}
      </div>

      <div className={styles.disclaimerSection}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Legal Disclaimer:
        </Typography>
        <Box sx={{ backgroundColor: "#f9f9f9", p: 3, borderRadius: 2 }}>
          <Typography variant="body1" gutterBottom>
            <strong>User Content Notice:</strong>  By uploading or embedding any content, you 
             represent that you are the rightful owner or authorized user of that content. FirstLand, Inc.
             is not responsible for any copyrighted material posted without permission. External media such as YouTube,
             Instagram, or Spotify must comply with their respective
             Terms of Service. All trademarks are property of their respective owners.
          </Typography>
        </Box>
      </div>
    </div>
  );
}

export default SocialMediaManager;
